// extracted by mini-css-extract-plugin
export default {"pickerWrap":"pickerWrap--FSd4l","shortcuts":"shortcuts--Pl8uF","darkText":"darkText--speLz","timeFramePlaceholder":"timeFramePlaceholder--sP6A5"};